import React from 'react';
import ExerciseInterface from './ExerciseSystem/ExerciseInterface';
import { M22_TOPICS, M22_MODULE_INFO } from '../data/mathExercises/M22_Statistics';
import { M22_ALL_PROBLEMS } from '../data/mathExercises/M22_ProblemsData';

const M22StatisticsExercise = ({ onProgress }) => {
  return (
    <ExerciseInterface
      moduleInfo={M22_MODULE_INFO}
      topics={M22_TOPICS}
      problems={M22_ALL_PROBLEMS}
      onProgress={onProgress}
      className="m22-exercise"
    />
  );
};

export default M22StatisticsExercise; 